let now = parseInt(document.querySelector(".countdown-now").innerHTML)
document.querySelector(".errorImg").src = require("@/assets/errorImg.png")
let toDashBoard = setInterval(function(){
    now--
    document.querySelector(".countdown-now").innerHTML = now
    if(parseInt(now) === 0){
        clearInterval(toDashBoard)
        location="/"
    }
   
},1000)
document.querySelector(".backButton").onclick = function(){
    window.history.back()
}